import { buildPathRibbonFrame, resolvePathRibbonParameters, } from "./path-ribbon.js";
import { ensureRingWinding, isSimpleRing } from "./ring.js";
export const DEFAULT_CORRIDOR_PARAMETERS = {
    widthPathRatio: 0.06,
    minimumWidthMeters: 1,
    maximumWidthMeters: 100_000,
    tension: 0.15,
    segmentsPerSpan: 16,
    miterLimit: 3,
};
export function resolveCorridorParameters(parameters = {}) {
    return resolvePathRibbonParameters({
        ...DEFAULT_CORRIDOR_PARAMETERS,
        ...parameters,
    });
}
export function buildCorridorRing(controlPoints, parameters = {}) {
    const resolved = resolveCorridorParameters(parameters);
    const frame = buildPathRibbonFrame(controlPoints, resolved);
    const ring = ensureRingWinding([...frame.left, ...frame.right.slice().reverse()], "counterclockwise");
    if (!isSimpleRing(ring, 1e-6)) {
        throw new RangeError("Corridor produced a self-intersecting ring; narrow the corridor or simplify the path.");
    }
    return ring.map((point) => frame.projection.unproject(point));
}
//# sourceMappingURL=corridor.js.map